import { t } from 'ember-intl'
import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import PageHeader from 'teacher-ui-client/components/page-header'
import type WritingLegendsVocabularyRoute from 'teacher-ui-client/reporting/ui-scope/writing-legends/vocabulary/route'
import { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import { TabGroupComponent } from 'teacher-ui-client/components/tab-group'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import ReportingControls from 'teacher-ui-client/components/reporting/controls'
import ReportingUiScopeSelect from 'teacher-ui-client/components/reporting/ui-scope-select'
import ReportingPeriodSelect from 'teacher-ui-client/components/reporting/period-select'
import ReportingControlsGap from 'teacher-ui-client/components/reporting/controls-gap'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface Signature {
  Args: {
    model: ModelFor<WritingLegendsVocabularyRoute>
  }
}

export const WritingLegendsVocabularyPage: TOC<Signature> = <template>
  <PageHeader>
    <:title>
      <h1>
        {{t "reporting.pageTitles.writingLegends.vocabulary"}}
      </h1>
    </:title>
  </PageHeader>

  <ReportingControls>
    <ReportingUiScopeSelect class="shrink basis-80" />
    <ReportingControlsGap />
    <ReportingPeriodSelect />
  </ReportingControls>

  <TabGroupComponent
    @theme={{themeKey SubscriptionType.Writing}}
    @tabType={{TAB_TYPE_KEYS.underline}}
    data-test-tab-group
    as |tabGroup|
  >
    <tabGroup.linkToTab
      data-test-vocabulary-tab="vocabulary-bank"
      @route="reporting.ui-scope.writing-legends.vocabulary.bank.new-words"
      @currentWhen="reporting.ui-scope.writing-legends.vocabulary.bank"
    >
      {{t "pages.wlVocabulary.tabs.vocabularyBank"}}
    </tabGroup.linkToTab>
    <tabGroup.linkToTab
      data-test-vocabulary-tab="overused-words-analyser"
      @route="reporting.ui-scope.writing-legends.vocabulary.overused-words-analyser"
    >
      {{t "pages.wlVocabulary.tabs.overusedWords"}}
    </tabGroup.linkToTab>
    <tabGroup.linkToTab
      data-test-vocabulary-tab="language-gems-analyser"
      @route="reporting.ui-scope.writing-legends.vocabulary.language-gems-analyser"
    >
      {{t "pages.wlVocabulary.tabs.languageGems"}}
    </tabGroup.linkToTab>
  </TabGroupComponent>
  {{outlet}}
</template>

export default RouteTemplate(WritingLegendsVocabularyPage)
